import { useState } from 'react';
import IconLoader from '../icons/loader';
import { DropzoneTypes } from './types';

import './dropzone.css';

export default function Dropzone({
  onUpload,
  fileUploadInProgress,
  inputRef,
  dropzoneText,
  dropzoneIcon,
  dropzoneTextClassName = '',
  dropzoneClassName = '',
  accept = '',
  children,
}: DropzoneTypes): React.JSX.Element {
  const [dropZoneActive, setDropZoneActive] = useState(false);

  return (
    <div
      className={`drop-zone ${
        dropZoneActive ? 'drop-zone-active' : ''
      } ${dropzoneClassName}`}
      onDrop={(e) => {
        e.stopPropagation();
        setDropZoneActive(false);
      }}
      onDragEnter={(e) => {
        setDropZoneActive(true);
        e.stopPropagation();
      }}
      onDragLeave={(e) => {
        setDropZoneActive(false);
        e.stopPropagation();
      }}
    >
      <div className="dropZoneText">
        {fileUploadInProgress ? (
          <IconLoader className="drop-zone-loader" />
        ) : (
          <div className={`drop-zone-text-content ${dropzoneTextClassName}`}>
            {dropzoneIcon && (
              <div className="drop-zone-icon">{dropzoneIcon}</div>
            )}
            {children}
            {dropzoneText}
          </div>
        )}
        <input
          type="file"
          className="drop-zone-input"
          onChange={(e) => onUpload(e.target.files as FileList)}
          ref={inputRef}
          accept={accept}
          autoComplete="off"
          multiple
        />
      </div>
    </div>
  );
}
